import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Lookup } from '@app/modules/lookup/models/lookup.model';
import { LookupService } from '@app/modules/lookup/services/lookup.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import moment from 'moment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordGrievance } from '../../models/employment-record-grievance.model';
import { EmploymentRecordGrievancesService } from '../../services/employment-record-grievances.service';

@Component({
  selector: 'app-employment-record-grievance-dialog',
  templateUrl: './employment-record-grievance-dialog.component.html',
  styleUrls: ['./employment-record-grievance-dialog.component.scss']
})
export class EmploymentRecordGrievanceDialogComponent implements OnInit {
  form: UntypedFormGroup;
  employmentRecordId: any;
  employeeId: any;
  grievanceId: any;
  isLoading: boolean;
  employmentRecordGrievance: EmploymentRecordGrievance;
  filedByOptions: Observable<Lookup[]>;
  finalResolutionOptions: Observable<Lookup[]>;
  statusOptions: Observable<Lookup[]>;
  typeOptions: Observable<Lookup[]>;

  constructor(
    private fb: UntypedFormBuilder,
    private lookupService: LookupService,
    private overlayService: OverlayService,
    private employmentRecordGrievancesService: EmploymentRecordGrievancesService,
    private snackbarService: SnackbarService,
    private dialogRef: MatDialogRef<EmploymentRecordGrievanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.employmentRecordId = data.employmentRecordId;
    this.employeeId = data.employeeId;
    this.grievanceId = data.GrievanceId;
  } 

  ngOnInit(): void {
    this.getLookups();

    this.grievanceId !== null 
      ? this.getEmploymentRecordGrievance() 
      : this.isLoading = false; 
        this.createForm();
  }

  getEmploymentRecordGrievance() {
    this.isLoading = true;
    
    this.employmentRecordGrievancesService.getGrievance(this.employeeId, this.employmentRecordId, this.grievanceId)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe(
      res => {
        this.employmentRecordGrievance = res;
        this.createForm();
      }
    );
  }

  getLookups() {
    this.filedByOptions = this.lookupService.getLookups("/lookup/GRIEVANCE_FILED_BY");
    this.finalResolutionOptions = this.lookupService.getLookups("/lookup/GRIEVANCE_FINAL_RESOLUTION");
    this.statusOptions = this.lookupService.getLookups("/lookup/GRIEVANCE_STATUS");
    this.typeOptions = this.lookupService.getLookups("/lookup/GRIEVANCE_TYPE");
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.employmentRecordGrievance ? this.employmentRecordGrievance.id : null],
      effectiveDate: [moment().format()],
      type: [this.employmentRecordGrievance && this.employmentRecordGrievance.type ? this.employmentRecordGrievance.type.id : null],
      date: [this.employmentRecordGrievance ? this.employmentRecordGrievance.date : null],
      filedBy: [this.employmentRecordGrievance && this.employmentRecordGrievance.filedBy ? this.employmentRecordGrievance.filedBy.id : null],
      shortDescription: [this.employmentRecordGrievance ? this.employmentRecordGrievance.shortDescription : null],
      description: [this.employmentRecordGrievance ? this.employmentRecordGrievance.description : null],
      status: [this.employmentRecordGrievance && this.employmentRecordGrievance.status ? this.employmentRecordGrievance.status.id : null],
      finalResolution: [this.employmentRecordGrievance && this.employmentRecordGrievance.finalResolution ? this.employmentRecordGrievance.finalResolution.id : null],
      changeReason: [''],
      changeReasonComments: ['']
    });
  }

  save(){
    this.overlayService.show();

    this.employmentRecordGrievancesService.postGrievance(this.employeeId, this.employmentRecordId, this.form.value)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.snackbarService.openSnackBar('Grievance saved successfully', 'clear', 'success');
        this.dialogRef.close(true);
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  close(){
    this.dialogRef.close();
  }

}

